import { useEffect, useState } from 'react';

/**
 * Get a data asynchronously and get realtime updates by using a subscription function.
 * @param subscribe subscribe to realtime updates
 * @param getSnapshot retrieves data asynchronously
 * @returns the data
 */
function useSyncData<T>(
    subscribe: (onValuehange: () => void) => void,
    getSnapshot: () => Promise<T>,
    dependencies: Array<any> = []
) {
    const [data, setData] = useState<T>();

    const updateData = () => {
        getSnapshot()
            .then((d: T) => {
                setData(d);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onValuehange = updateData;

    useEffect(() => {
        updateData();
        return subscribe(onValuehange);
    }, dependencies);

    return data;
}

export default useSyncData;
